module.exports = __webpack_public_path__ + "img/Github-black.c019a8fc.svg";